import React from 'react'
import { RouteComponentProps, Redirect } from 'react-router-dom'
import {
  useFlag,
  routes,
  DynamicLoadingPage,
  NotFoundView,
} from '@sketch/modules-common'
import { PreviewLayout } from './PreviewLayout'
import { PageCanvasView } from './PageCanvasView'
import { PreviewContextProvider } from './PreviewContext'
import { ShareViewsNavigationContextProvider } from '../../utils/shareViewsNavigation'
import { useGetPreviewDetailsQuery } from '@sketch/gql-types'

type PreviewViewProps = RouteComponentProps<{
  previewID: string
}>

export const PreviewView: React.FC<PreviewViewProps> = ({ match }) => {
  const isPartialSharingEnabled = useFlag('partial-sharing')
  const { previewID } = match.params
  const { data, loading, error } = useGetPreviewDetailsQuery({
    variables: {
      previewIdentifier: previewID,
    },
  })
  if (!isPartialSharingEnabled) {
    return <Redirect to={routes.ENTRY.create({})} />
  }

  if (loading) {
    return <DynamicLoadingPage />
  }

  if (error || !data?.preview) {
    return (
      <NotFoundView
        title="We cannot find this document."
        additionalMessage=" It might have been deleted or moved, or you could have the wrong URL
            for it."
      />
    )
  }

  const preview = data.preview

  return (
    <ShareViewsNavigationContextProvider>
      <PreviewContextProvider preview={preview}>
        <PreviewLayout
          render={layoutProps => (
            <PageCanvasView preview={preview} {...layoutProps} />
          )}
        />
      </PreviewContextProvider>
    </ShareViewsNavigationContextProvider>
  )
}
